export default __webpack_public_path__ + "65c5a94fdd9d3515fc9cf131572a58ff.png";